<fieldset [ngClass]="{'ng-invalid': !selectedAtgard && isAtgardRequired }">
  <label [raskRequired]="isAtgardRequired">
    Yta att hämta geometrier ifrån
  </label>

  @if (listOfAtgarder) {
    <ng-select
      [ngModel]="selectedAtgard"
      [items]="listOfAtgarder"
      (change)="skogsvardAtgardChanged($event)"
      [clearable]="true">
      <ng-template ng-option-tmp ng-label-tmp let-item="item">
        @if (!item.isSkogsvard) {
          <rask-atgard-badge [index]="item.index + 1"
          [avverkningsgrupp]="item.grupp"></rask-atgard-badge>
        }
        @if (item.isSkogsvard) {
          <rask-skogsvard-badge [index]="item.index + 1"
          [skogsvardTyp]="item.grupp"></rask-skogsvard-badge>
        }
        {{item.text}}
      </ng-template>
    </ng-select>
  }
    @if(showCopyGeometries) {
    <rask-checkbox text="Hämta övriga geometrier från kontrakt"
        (change)="copyContractGeometriesChanged($event)"></rask-checkbox>
    }

</fieldset>